import { format } from 'date-fns';
import styled from 'styled-components';
import { LinkId } from '../../AnalyticsContext/LinkId';
import { ThemeColours } from '../../styles/ThemeColours';
import { PRESSABLE_LINK } from '../../styles/constants';
import { now } from '../../util/now';
import { Link } from '../Link';
import { SocialLinks } from './SocialLinks';

export const BottomLine = () => (
  <View>
    <Segment>© {format(now(), 'yyyy')} Healthengine</Segment>

    <Segment>
      <StyledLink to="/terms.php" trackingId={LinkId.FOOTER}>
        Terms of Use
      </StyledLink>
    </Segment>

    <Segment>
      <StyledLink to="/privacy.php" trackingId={LinkId.FOOTER}>
        Privacy Policy
      </StyledLink>
    </Segment>

    <Segment>
      <SocialLinks />
    </Segment>
  </View>
);

const View = styled.div`
  align-items: center;
  color: ${ThemeColours.mono900};
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  font-size: 14px;
`;

const Segment = styled.div`
  line-height: 24px;
  margin-bottom: 20px;

  &:not(:last-child) {
    border-right: solid 1px ${ThemeColours.mono300};
    margin-right: 16px;
    padding-right: 16px;
  }
`;

const StyledLink = styled(Link)`
  ${PRESSABLE_LINK}
  color: inherit;
  text-decoration: none;

  &:hover {
    color: ${ThemeColours.mono700};
    text-decoration: underline;
  }
`;
